export default "__VITE_ASSET__CiklsLoL__"